import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionToken } from 'app/modules/darwin/models/session-token';
import { AncillaryEndpointsService } from 'app/modules/main/services/ancillary-endpoints.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SessionTokenService {

  constructor(
    private readonly http: HttpClient,
    private readonly serviceEndpoints: AncillaryEndpointsService,
  ) {
  }

  public fetch(): Observable<string> {

    const url = this.serviceEndpoints.sessionTokenUrl;

    return this.http.get<SessionToken>(url)
      .pipe(map(response => response.sessionToken));
  }

}
